module.exports = require("./uk-UA.js");